import React from 'react';
import { motion } from 'framer-motion';
import { Bell, ArrowRightLeft } from 'lucide-react'; // Using a transaction-like icon
import { Link } from 'react-router-dom'; // Assuming you're using react-router
import { encryptRef } from 'utils/encryption';

export const Notification = ({ note }) => {
  // Determine the icon based on the type
  const Icon = note.type === 'transaction' ? ArrowRightLeft : Bell;

  const encRef = encryptRef(note.transaction?.tx_ref);

  // Determine the link for transaction type
  const link = note.type === 'transaction' 
    ? `/app/transactions/${note.transaction.id}` 
    : null;

  const NotificationContent = (
    <motion.div
      key={note.id}
      whileHover={{ scale: 1.01 }}
      className={`p-4 rounded-2xl backdrop-blur-md shadow-md ${
        note.seen === 1 ? 'bg-white/10' : 'bg-white/5'
      }`}
    >
      <div className="flex justify-between items-start">
        <div className="flex items-center gap-3">
          <div className="p-2 rounded-full bg-white/10">
            <Icon className="w-5 h-5 text-white/80" />
          </div>
          <div>
            <p className="text-white font-medium">{note.title}</p>
            <p className="text-white/50 font-light text-sm">{note.message}</p>
            <p className="text-white/50 text-xs mt-1">
              {new Date(note.createdAt).toLocaleString('en-US', {
                dateStyle: 'medium',
                timeStyle: 'short',
              })}
            </p>
          </div>
        </div>
        <span className="text-xs bg-white/10 rounded-md p-1 text-white/40 uppercase">
          {note.category || note.type}
        </span>
      </div>
    </motion.div>
  );

  return (
    <div>
      {link ? (
        <Link to={`/app/transactions/${encRef}`}>
          {NotificationContent}
        </Link>
      ) : (
        NotificationContent
      )}
    </div>
  );
};
